import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
}
export function Card({
  children,
  className = '',
  title
}: CardProps) {
  return <div className={`bg-dark-card border border-gray-800 rounded-lg overflow-hidden shadow-xl ${className}`} data-id="element-135">
      {title && <div className="bg-primary/10 border-b border-gray-800 px-4 py-3" data-id="element-136">
          <h3 className="text-lg font-retro text-primary" data-id="element-137">{title}</h3>
        </div>}
      <div className="p-4" data-id="element-138">{children}</div>
    </div>;
}